import * as React from "react";
interface iconprop {}
const TravAssistShaded = (props: iconprop) => (
  <svg
    width={72}
    height={81}
    viewBox="0 0 72 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      y={0.449219}
      width={72}
      height={80}
      rx={8}
      fill="url(#paint0_linear_841_14840)"
    />
    <g clipPath="url(#clip0_841_14840)">
      <mask
        id="mask0_841_14840"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={12}
        y={16}
        width={48}
        height={49}
      >
        <path
          d="M51.8919 16.4492H20.1081C15.6301 16.4492 12 20.0793 12 24.5573V56.3411C12 60.8191 15.6301 64.4492 20.1081 64.4492H51.8919C56.3699 64.4492 60 60.8191 60 56.3411V24.5573C60 20.0793 56.3699 16.4492 51.8919 16.4492Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_841_14840)">
        <path
          d="M51.8919 16.4492H20.1081C15.6301 16.4492 12 20.0793 12 24.5573V56.3411C12 60.8191 15.6301 64.4492 20.1081 64.4492H51.8919C56.3699 64.4492 60 60.8191 60 56.3411V24.5573C60 20.0793 56.3699 16.4492 51.8919 16.4492Z"
          fill="url(#paint1_linear_841_14840)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.3208 16.4492H52.2127C56.6907 16.4492 60.3208 20.0793 60.3208 24.5573V56.3411C60.3208 60.8191 56.6907 64.4492 52.2127 64.4492H36.3208V16.4492Z"
          fill="url(#paint2_radial_841_14840)"
        />
      </g>
      <path
        d="M47.0768 41.7692V39.5261C47.0768 36.5884 45.9099 33.7707 43.8324 31.6936C41.7552 29.6162 38.9376 28.4492 35.9999 28.4492C33.0622 28.4492 30.2445 29.6162 28.1674 31.6936C26.0899 33.7709 24.923 36.5884 24.923 39.5261V41.7692C24.3491 42.1351 24.0011 42.7683 24 43.4491V45.4491C24 45.9794 24.2107 46.4882 24.5857 46.8634C24.9609 47.2384 25.4697 47.4491 26 47.4491C26 47.9794 26.2107 48.4882 26.5857 48.8634C26.9609 49.2384 27.4696 49.4491 28 49.4491H29C29.3977 49.4491 29.7795 49.291 30.0607 49.0098C30.3419 48.7285 30.4999 48.3468 30.4999 47.9491V40.9491C30.4999 40.5514 30.3419 40.1697 30.0607 39.8885C29.7794 39.6073 29.3977 39.4492 29 39.4492H28C27.4696 39.4492 26.9609 39.6599 26.5857 40.0349C26.2107 40.4101 26 40.9188 26 41.4492C25.9734 41.4492 25.95 41.4561 25.923 41.4572V39.5262C25.9232 37.6159 26.4703 35.7456 27.5 34.1367L28.3529 34.9903C28.4563 35.0954 28.6014 35.1486 28.748 35.1352C28.8947 35.1231 29.0286 35.0468 29.1141 34.9267C30.7005 32.6991 33.2652 31.3752 35.9998 31.3723C38.2428 31.3647 40.3953 32.2568 41.9752 33.8493C42.3095 34.1808 42.6142 34.5412 42.8852 34.9263C42.9703 35.0468 43.104 35.1236 43.2506 35.1363H43.293H43.2932C43.4258 35.1363 43.5531 35.0837 43.6468 34.9897L44.4997 34.1368C45.5294 35.7457 46.0765 37.616 46.0768 39.5262V41.4573C46.0509 41.4573 46.0268 41.4492 45.9997 41.4492C45.9997 40.9189 45.789 40.4102 45.414 40.035C45.0388 39.66 44.5301 39.4492 43.9998 39.4492H42.9998C42.602 39.4492 42.2203 39.6073 41.9391 39.8885C41.6579 40.1698 41.4998 40.5515 41.4998 40.9492V47.9492C41.5007 48.3405 41.6542 48.7159 41.9279 48.9954C42.2016 49.2751 42.5737 49.4365 42.9648 49.4456C42.8549 49.8746 42.6058 50.2548 42.2565 50.5269C41.9072 50.799 41.4775 50.9476 41.0348 50.9492H39.4998C39.4998 50.5514 39.3418 50.1697 39.0605 49.8885C38.7793 49.6073 38.3976 49.4492 37.9998 49.4492H36.9998C36.4639 49.4492 35.9688 49.7352 35.7008 50.1992C35.4329 50.6633 35.4329 51.2352 35.7008 51.6992C35.9688 52.1633 36.4639 52.4492 36.9998 52.4492H37.9998C38.4242 52.4479 38.8277 52.266 39.1099 51.9492H41.0349C41.7434 51.9486 42.4287 51.697 42.9695 51.2396C43.5103 50.782 43.8717 50.1477 43.9898 49.4492H43.9998C44.5302 49.4492 45.0389 49.2385 45.4141 48.8635C45.7891 48.4883 45.9998 47.9796 45.9998 47.4492C46.5301 47.4492 47.0389 47.2385 47.4141 46.8635C47.7891 46.4883 47.9998 45.9796 47.9998 45.4492V43.4493C47.9987 42.7685 47.6507 42.1352 47.0768 41.7694V41.7692ZM25.9998 46.4491C25.7346 46.4491 25.4801 46.3437 25.2926 46.1562C25.1051 45.9687 24.9998 45.7143 24.9998 45.4491V43.4491C24.9998 43.1839 25.1051 42.9295 25.2926 42.742C25.4801 42.5545 25.7346 42.4491 25.9998 42.4491V46.4491ZM46.9997 45.4491C46.9997 45.7143 46.8943 45.9687 46.7068 46.1562C46.5193 46.3437 46.2649 46.4491 45.9997 46.4491V42.4491C46.2649 42.4491 46.5193 42.5545 46.7068 42.742C46.8943 42.9295 46.9997 43.1839 46.9997 43.4491V45.4491Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_841_14840"
        x1={0}
        y1={0.449219}
        x2={64.7822}
        y2={41.4106}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#474747" />
        <stop offset={0.872554} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint1_linear_841_14840"
        x1={36}
        y1={16.4492}
        x2={23.0426}
        y2={65.639}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#027863" />
        <stop offset={1} stopColor="#163E36" />
      </linearGradient>
      <radialGradient
        id="paint2_radial_841_14840"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(55.1669 16.4492) rotate(110.807) scale(53.6954 47.7027)"
      >
        <stop stopColor="#00E6BC" />
        <stop offset={1} stopColor="#01715D" stopOpacity={0} />
      </radialGradient>
      <clipPath id="clip0_841_14840">
        <rect x={12} y={16.4492} width={48} height={48} rx={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export { TravAssistShaded };
